// extracted by mini-css-extract-plugin
module.exports = {"component":"cta-link-list_component__qnqe9","item":"cta-link-list_item__fM4LD"};